import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Hidden, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, } from "@material-ui/core";
import { locales } from "frontend/src/domain/localization/i18n";
import { RightholderLayout } from "frontend/src/pages/layouts/rightholder";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { usePageModel } from "./model";
var Page = function () {
    var t = useTranslation(locales.namespaces.rightholder).t;
    var _a = usePageModel(), tracks = _a.tracks, rowsPerPage = _a.rowsPerPage, page = _a.page, onChangeRowsPerPage = _a.onChangeRowsPerPage, onChangePage = _a.onChangePage;
    return (React.createElement(Box, null,
        React.createElement(Box, { component: Paper },
            React.createElement(TableContainer, { component: Paper },
                React.createElement(Table, null,
                    React.createElement(Hidden, { xsDown: true },
                        React.createElement(TableHead, null,
                            React.createElement(TableRow, null,
                                React.createElement(TableCell, null, t("pages.tracks.table.title")),
                                React.createElement(TableCell, null, t("pages.tracks.table.artist")),
                                React.createElement(TableCell, null, t("pages.tracks.table.genres")),
                                React.createElement(TableCell, null, t("pages.tracks.table.duration"))))),
                    React.createElement(TableBody, null,
                        tracks.data &&
                            tracks.data.tracks.map(function (track) {
                                return (React.createElement(TableRow, { key: track.id },
                                    React.createElement(TableCell, null, track.title),
                                    React.createElement(TableCell, null, track.artist),
                                    React.createElement(TableCell, null, track.genres.map(function (genre) { return genre.title; }).join(", ")),
                                    React.createElement(TableCell, null, track.duration.formatted)));
                            }),
                        tracks.isLoading && React.createElement(TableRowsSkeleton, { rows: 10, columns: 4 })))),
            tracks.data && (React.createElement(TablePagination, { component: Paper, count: tracks.data.total, page: page, onPageChange: onChangePage, rowsPerPage: rowsPerPage, onRowsPerPageChange: onChangeRowsPerPage, labelRowsPerPage: t("pages.tracks.table.rowsPerPage") })))));
};
export var TracksPage = function () {
    return (React.createElement(RightholderLayout, null,
        React.createElement(Page, null)));
};
